/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userassetsstat.vue?vue&type=template&id=6d8c53a0&scoped=true"
import script from "./userassetsstat.vue?vue&type=script&lang=js"
export * from "./userassetsstat.vue?vue&type=script&lang=js"
import style0 from "./userassetsstat.vue?vue&type=style&index=0&id=6d8c53a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8c53a0",
  null
  
)

export default component.exports